import { motion } from 'framer-motion';
import { Code2, Sparkles } from 'lucide-react';
import favicon from '../assets/favicon.png';

export const Hero = () => {
  const scrollToServices = () => {
    const element = document.querySelector('#servicos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="min-h-screen relative flex items-center overflow-hidden"
    >
      {/* Background Elements */}
      <div className="absolute inset-0">
        {/* Grid Pattern */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(#A2A092 1px, transparent 1px), linear-gradient(90deg, #A2A092 1px, transparent 1px)`,
            backgroundSize: '80px 80px'
          }}
        />

        {/* Floating Icon */}
        <div className="absolute right-[10%] top-1/4 hidden lg:block opacity-10">
          <img
            src={favicon}
            alt=""
            className="w-64 h-64"
          />
        </div>
      </div>

      {/* Content */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-32 pb-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-12 flex flex-col items-center text-center">
            {/* Title */}
            <motion.h1
              data-testid="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-[0.9] text-brand-light mb-10"
            >
              Transformamos
              <br />
              <span className="text-gradient">ideias em código.</span>
              <br />
            </motion.h1>

            {/* Description */}
            <motion.p
              data-testid="hero-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="font-body text-lg md:text-xl text-brand-light/70 max-w-xl mx-auto leading-relaxed mb-12"
            >
              Criamos landing pages, sites, e-commerces e automações
              que impulsionam seu negócio para o próximo nível.
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <button
                data-testid="hero-cta-primary"
                onClick={() => window.open('https://wa.me/5585985655143', '_blank', 'noopener,noreferrer')}
                className="btn-primary flex items-center justify-center gap-3"
              >
                <Sparkles size={18} />
                Começar Projeto
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={scrollToServices}
                className="btn-outline flex items-center justify-center gap-3"
              >
                <Code2 size={18} />
                Ver Serviços
              </button>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};
